import styled from 'styled-components';
import media from 'src/styles/Media.styled';
export const SubTitleComponent = styled.p`
    font-family: 'AvenirNextWorld Demi';
    font-size: 20px;
    align-content: 'left';
    color: #140f4b;
`;
export const SpaceDiv = styled.div`
    ${media.mobileDevice`
    width:18px;
`}
`;
